const elementName = 'aceii-court-moments';

if (
  typeof window !== 'undefined'
  && typeof HTMLElement !== 'undefined'
  && !window.customElements.get(elementName)
) {
  class AceiiCourtMoments extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.gallery = this.querySelector('[data-court-gallery]');
      this.cards = [...this.querySelectorAll('[data-court-card]')];
      this.mobileQuery = window.matchMedia('(max-width: 760px)');
      this.activeCard =
        this.querySelector('[data-court-card].is-active') ?? this.cards[0];
      this.revealTimer = 0;

      if (!this.gallery || !this.cards.length) return;

      const { signal } = this.abortController;

      this.cards.forEach((card) => {
        card.addEventListener('mouseenter', () => {
          if (!this.mobileQuery.matches) this.setActive(card);
        }, { signal });
        card.addEventListener('focus', () => {
          if (!this.mobileQuery.matches) this.setActive(card);
        }, { signal });
        card.addEventListener('click', () => this.setActive(card), {
          signal,
        });
      });

      this.gallery.addEventListener(
        'mouseleave',
        () => {
          if (!this.mobileQuery.matches) this.setActive(this.cards[0]);
        },
        { signal },
      );
      this.mobileQuery.addEventListener('change', () => this.syncAria(), {
        signal,
      });

      this.setActive(this.activeCard, true);
    }

    disconnectedCallback() {
      window.clearTimeout(this.revealTimer);
      this.abortController?.abort();
      this.revealTimer = 0;
      this.abortController = null;
    }

    setActive(card, immediate = false) {
      if (!card) return;

      window.clearTimeout(this.revealTimer);
      this.cards.forEach((item) => {
        item.classList.remove('is-active', 'is-revealed');
      });

      this.activeCard = card;
      card.classList.add('is-active');
      this.syncAria();

      if (immediate || this.mobileQuery.matches) {
        card.classList.add('is-revealed');
        return;
      }

      this.revealTimer = window.setTimeout(() => {
        if (this.activeCard === card) card.classList.add('is-revealed');
      }, 520);
    }

    syncAria() {
      this.cards.forEach((card) => {
        const expanded =
          this.mobileQuery.matches || card === this.activeCard;
        card.setAttribute('aria-expanded', String(expanded));
      });
    }
  }

  window.customElements.define(elementName, AceiiCourtMoments);
}
